jQuery(function($) {

    //let windowWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    function d6_set_tabs_height(tabs) {

        let maxHeight = 0;

        $(tabs).each(function(index, tab) {
            if($(tab).height() > maxHeight) {
                maxHeight = $(tab).height();
            }
        });

        return maxHeight;
    }

    $('.d6-block--contact-forms').each(function() {

        let contactForm = $(this);

        $(this).find('.cf-tab-header-item').click(function(){

            if( !$(this).hasClass('active') ) {

                let target = $(this).data('target');

                contactForm.find('.cf-tab-header-item').removeClass('active');
                contactForm.find('.cf-tab-content-item').removeClass('active');

                $(this).addClass('active');
                contactForm.find('.cf-tab-content-item[data-target="' + target + '"]').addClass('active');
            }

            $([document.documentElement, document.body]).animate({
                scrollTop: $(this).offset().top
            }, 300);
            
        });

        $('.question').click(function() {
            var panel = $(this).next('.answer');
        
            if (panel.is(':hidden')) {
                $('.answer').slideUp();
                $('.question').removeClass('acc-expanded');
                $(this).closest('.question').addClass('acc-expanded');
                panel.slideDown();
            } else {
                $('.answer').slideUp();
                $('.question').removeClass('acc-expanded');
            }
          });
          
    });

    // $('.d6-block--contact-forms').each(function() {

    //     let tabTriggers = $(this).find('.cf-tab-header-ctn .cf-tab-header');
    //     let tabItems = $(this).find('.cf-tab-content-ctn .cf-tab-content');

    //     $(window).on('load', function() {
    //         $(this).find('.cf-tab-header-ctn').first().css('min-height', d6_set_tabs_height(tabItems));
    //         //$(tabElement).find('.d6-block--tabbed-tabs').find('.d6-block--tabbed-tabs-tabitem-content').css('min-height', d6_set_tabs_height(tabItems));
    //     });
    //     // $(tabItems).hide();

    //     // let tabItemsFirst = $(tabItems).first();
    //     // $(tabItemsFirst).addClass('active');
    //     // $(tabItemsFirst).fadeIn();


    //     $(tabTriggers).each(function() {

    //         //let tabTriggerAnchor = $(this).find('a').first();
            
    //         $(this).on('click', function(e) {
    //             //e.preventDefault();

    //             if( $(this).hasClass('active') ) return;

    //             let tabTriggersTargetID = $(this).data('target');

                
    //             tabItems.removeClass('active');
    //             $('.cf-tab-content-ctn .cf-tab-content[data-target="' + tabTriggersTargetID + '"]').addClass('active');
    //             //tabItems.attr('data-target')

    //             // Remove active from all tab triggers in this group
    //             // $(tabTriggers).removeClass('active');
    //             // $(tabTriggers).each(function(k, thisTrigger) {
    //             //     let thisTriggerAnchor = $(thisTrigger).find('a').first();
    //             //     $(thisTriggerAnchor).attr('tabindex', '-1');
    //             // });

    //             // $(tabItems).hide(0, function() {
    //             //     setTimeout(() => {
    //             //         // Add active class to clicked tab trigger
    //             //         $(tabTriggers).removeClass('active');
    //             //         $(tabTrigger).addClass('active');
    //             //         $(tabTriggerAnchor).removeAttr('tabindex');
                        
    //             //         $(`#${tabTriggersTargetID}`).show(0);
    //             //       }, 100);
    //             // });
    //         });

    //         $(tabTriggerAnchor).on("focus", function(event) {

    //             $(tabTriggerAnchor).on('keydown', function(e) {
    //                 if(e.keyCode == 37) { // left
    //                     let $prevTrigger = $(tabTrigger).prev();
    //                     if($prevTrigger.length <= 0) {
    //                         $(tabTriggers).last().find('a').first().focus();
    //                         $(tabTriggers).last().find('a').first().click();
    //                     }
    //                     else {
    //                         $prevTrigger.find('a').first().focus();
    //                         $prevTrigger.find('a').first().click();
    //                     }
    //                 }
    //                 else if(e.keyCode == 39) { // right
    //                     let $nextTrigger = $(tabTrigger).next();
    //                     if($nextTrigger.length <= 0) {
    //                         $(tabTriggers).first().find('a').first().focus();
    //                         $(tabTriggers).first().find('a').first().click();
    //                     }
    //                     else {
    //                         $nextTrigger.find('a').first().focus();
    //                         $nextTrigger.find('a').first().click();
    //                     }
    //                 }
    //             });

    //             $(this).off(event);
    //         });
    //     });
    // });

    
    // const columnsArgs = {
    //     dots: false,
    //     infinite: false,
    //     centerMode: false,
    //     variableWidth: true,
    //     autoplay: false,
    //     swipeToSlide: true,
    //     arrows: false,
    //     // arrowsPlacement: 'afterSlides'
    // };
    
    // if(windowWidth < 1024) {
    //     $('.d6-block--tabbed-tabs-list-wrapper').slick(columnsArgs);

    //     // $('.d6-block--tabbed-tabs-list-wrapper').each(function(index, element) {
    //     //     let slickSlider = $(element).slick(columnsArgs);

    //     //     $(element).find('.d6-block--tabbed-tabs-list-item > a').click(function(e) {
    //     //         e.preventDefault();
    //     //         let thisSlideItemIndex = $(this).parents('.slick-slide').data('slick-index');
    //     //         console.log(thisSlideItemIndex);
    //     //         slickSlider.slick('slickGoTo', thisSlideItemIndex);
    //     //     });
    //     // });

    //     $('.d6-block--tabbed-tabs-tabitem-content_copy-cta > a').addClass('acosta-button');
    // }
});